import { Currency } from "@redotech/money/currencies";
import * as z from "zod";

export const getLocalizedBillingStatus = {
  name: "getLocalizedBillingStatus" as const,
  input: z.object({}),
  output: z.discriminatedUnion("available", [
    z.object({ available: z.literal(false) }),
    z.object({
      available: z.literal(true),
      currency: z.enum(Currency),
      publishableKey: z.string(),
      paymentMethod: z
        .object({
          brand: z.string().nullable(),
          last4: z.string().nullable(),
          expMonth: z.number().nullable(),
          expYear: z.number().nullable(),
        })
        .nullable(),
    }),
  ]),
};
